module.exports = __webpack_public_path__ + "img/girl-clouds.c386cae2.png";